import { call, put, select } from 'redux-saga/effects';
import { updateToken } from '../../../actions/user';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* manageInvites({ payload }) {
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl}${RESOURCES.V3}/users/invite`;
  const { success, error } = yield call(callAPI, {
    url,
    method: METHODS.PUT,
    body: payload,
  });

  if (success && !error) {
    yield put(updateToken());
  } else {
    console.error(error);
  }
}
